import { render, staticRenderFns } from "./edit_share.vue?vue&type=template&id=052cab8d&scoped=true"
import script from "./edit_share.vue?vue&type=script&lang=js"
export * from "./edit_share.vue?vue&type=script&lang=js"
import style0 from "./edit_share.vue?vue&type=style&index=0&id=052cab8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052cab8d",
  null
  
)

export default component.exports